import { useReactiveVar } from '@apollo/client';
import { useFormContext } from '@cvent/carina/components/Forms';

import { coreProducts } from '@data/Products';
import { localeVar } from '@components/framework/ReactiveVars';
import { useCallback } from 'react';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ValidateOnLanguageChange = (): JSX.Element => {
  const language = useReactiveVar(localeVar);
  const { getAllErrors, runValidation } = useFormContext();

  const triggerErrorValidations = useCallback(async () => {
    if (language) {
      const err = getAllErrors();
      for (const [errKey, errVal] of Object.entries(err)) {
        if (errVal) {
          await runValidation(errKey);
        }
      }
    }
  }, [getAllErrors, language, runValidation]);

  triggerErrorValidations();

  return null;
};

export const validateFormField = (field: string, err: string): Array<string> | undefined => {
  if (field === '' || field === undefined) {
    return [err];
  }

  return undefined;
};

export const validateEmailFormField = (field: string, err: string): Array<string> | undefined => {
  if (String(field).toLowerCase().match(EMAIL_PATTERN)) {
    return undefined;
  }
  return [err];
};

export const isCoreProduct = (productId: string): boolean => {
  return coreProducts.find(v => v.id === productId) !== undefined;
};
